import React from 'react';

import { Button, Modal } from '@common/index';
import { Stack } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { flowActions, tabActions } from '@store/slices';
import { AppDispatch, State } from '@store/index';
import { Warning } from '@mui/icons-material';
import { findNeighbourTab } from '@common/FileTabs';
import { useTheme } from '../../styles/theme';

export const CloseTab: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const theme = useTheme();

  const tabs = useSelector((state: State) => state.tabs.list);
  const last_menu = useSelector((state: State) => state.tabs.last_menu);
  const open = useSelector((state: State) => state.flow.closeTab);
  const setOpen = (val: string | null) => dispatch(flowActions.setCloseTab(val));

  const { service_id, workflow_id } = useParams();

  const discard = () => {
    if (!open) return;

    setOpen(null);

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [n_flow_id, n_path, n_tab_name] = findNeighbourTab(tabs, open, last_menu);

    if (workflow_id !== open) {
      dispatch(tabActions.removeTab(open || ''));
      return;
    }

    if (n_flow_id === 'last' && last_menu) {
      navigate(last_menu || `/${service_id}/workflow`);
      dispatch(tabActions.removeTab(open || ''));
      return;
    }

    if (n_flow_id === 'workflow') {
      navigate(last_menu || `/${service_id}/workflow`);
      dispatch(tabActions.removeTab(open || ''));
      return;
    }

    if (n_flow_id !== 'workflow' && n_flow_id && n_tab_name) {
      dispatch(tabActions.setIdentifier(n_flow_id));
      navigate(`/${service_id}/workflow/${n_flow_id}`);
    }

    dispatch(tabActions.removeTab(open || ''));
  };

  return (
    <Modal
      open={Boolean(open)}
      setOpen={setOpen as (val: boolean | string | null) => void}
      header='Unsaved Changes'
      background={theme.telnyx.orange}
      icon={<Warning />}
      info='There are unsaved changes in this tab. Are you sure you want to discard them?'
      actions={
        <Stack direction='row' spacing={1}>
          <Button small onClick={() => setOpen(null)}>
            Back
          </Button>
          <Button small customColor='orange' onClick={discard}>
            Discard
          </Button>
        </Stack>
      }
    />
  );
};
